import { setSessionStorage } from 'helpers/common'

export const OAUTH_STATE_STORAGE_KEY = 'oauthState'

export function createOAuthState(): string {
  const webCrypto =
    typeof globalThis !== 'undefined' ? globalThis.crypto : undefined

  if (webCrypto && typeof webCrypto.randomUUID === 'function') {
    return webCrypto.randomUUID()
  }

  if (webCrypto && typeof webCrypto.getRandomValues === 'function') {
    const bytes = new Uint8Array(16)
    webCrypto.getRandomValues(bytes)

    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join(
      '',
    )
  }

  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
}

function normalizeIamUrl(url: string | undefined): string {
  if (!url) {
    return ''
  }

  const trimmed = url.replace(/\/$/, '')

  return trimmed.endsWith('/auth') ? trimmed.slice(0, -5) : trimmed
}

export const redirectToSSOLogin = (): void => {
  const {
    REACT_APP_IAM_PUBLIC_URL: IAM_PUBLIC_URL,
    REACT_APP_IAM_CLIENT_ID: CLIENT_ID,
    REACT_APP_IAM_REDIRECT_URL: REDIRECT_URL,
  } = window._env_

  const state = createOAuthState()
  setSessionStorage(OAUTH_STATE_STORAGE_KEY, state)

  const authorizeParams = new URLSearchParams({
    client_id: CLIENT_ID || '',
    redirect_uri: REDIRECT_URL || '',
    response_type: 'code',
    state,
  })

  window.location.href = `${normalizeIamUrl(
    IAM_PUBLIC_URL,
  )}/v1/auth/authorize?${authorizeParams.toString()}`
}
